import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { InvestmentGroups } from './master-master-groups-fundos.models';
const BASE_PATH = environment.basePath;
@Injectable({
  providedIn: 'root'
})
export class MasterMasterGroupsFundosService {

  constructor(
    private _$http: HttpClient
  ) { }

  getInvestmentGroups(payload: any):any {
    return this
            ._$http
            .post<any[]>(`${BASE_PATH}/bff/master/investmentGroup/viewOnly`, payload)
            .toPromise();
  }

}
